import { useTranslation } from '@e-kyc/translations';
import { useController } from 'react-hook-form';

import { Form } from '../../../../../../components';

export interface ExpirationDateInputGroupProps {
  dayOptions: Form.FormSelectOption[];
  monthOptions: Form.FormSelectOption[];
  expiryYearOptions: Form.FormSelectOption[];
  customRenderMonthDisplayValue: (value: Form.FormSelectOption['value']) => string;
}

export default function ExpirationDateInputGroup(props: Readonly<ExpirationDateInputGroupProps>) {
  const { dayOptions, monthOptions, expiryYearOptions, customRenderMonthDisplayValue } = props;
  const { t } = useTranslation();
  const {
    fieldState: { error },
  } = useController({
    name: 'cardExpirationDate',
  });

  return (
    <div>
      <p className='after:text-danger mb-2 text-start text-sm font-semibold after:ml-1 after:content-["*"]'>
        {t('idCardDetails.form.cardExpirationDate.label')}
      </p>
      <div className='relative grid w-full grid-cols-3 gap-2'>
        <Form.Select
          name='cardExpirationDate.date'
          placeholder={t('idCardDetails.form.placeholder.day')}
          options={dayOptions}
          classNameOverrides={{
            optionWrapper: 'mx-4 w-[calc(100%-32px)] [--anchor-max-height:160px] left-0!',
          }}
          inputMode='numeric'
        />
        <Form.Select
          name='cardExpirationDate.month'
          placeholder={t('idCardDetails.form.placeholder.month')}
          options={monthOptions}
          classNameOverrides={{
            optionWrapper: 'mx-4 w-[calc(100%-32px)] [--anchor-max-height:160px] left-0!',
          }}
          renderDisplayValue={customRenderMonthDisplayValue}
          disableInput
        />
        <Form.Select
          name='cardExpirationDate.year'
          placeholder={t('idCardDetails.form.placeholder.year')}
          options={expiryYearOptions}
          classNameOverrides={{
            optionWrapper: 'mx-4 w-[calc(100%-32px)] [--anchor-max-height:160px] left-0!',
          }}
          inputMode='numeric'
        />
      </div>
      <p className='text-text-secondary mt-2 text-xs'>
        {t('idCardDetails.form.cardExpirationDate.helperText')}
      </p>
      <p className='text-danger mt-2 text-sm'>{error?.root?.message}</p>
    </div>
  );
}
